import React, { useState } from 'react';
import { useParams } from 'react-router';

import useGetContractDetailsFromCache from '@/hooks/contract/useGetContractDetailsFromCache.hook';

import UpdateCustomerModal from './components/UpdateCustomerModal';
import OptionButton from '@/components/common/OptionButton/OptionButton';
import EditIcon from '@/components/common/OptionButton/icons/Edit/EditIcon';
import { UpdateContractCustomerInputType } from
  '@/graphql/contracts/_generated_/contracts';
import useUpdateContractCustomer from '@/pages/ContractDetails/ContractParties/hooks/useUpdateContractCustomer';


export default function UpdateCustomerContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const contract = useGetContractDetailsFromCache(contractId);
  const { updateContractCustomer } = useUpdateContractCustomer();

  const handleSubmit = async (newContractCustomer: UpdateContractCustomerInputType) => {
    const data = await updateContractCustomer(newContractCustomer);
    if (data) {
      setIsOpenEditModal(false);
    }
  };

  return (
    <>
      {isOpenEditModal && contract && (
        <UpdateCustomerModal
          onSubmit={handleSubmit}
          onClose={() => setIsOpenEditModal(false)}
          contract={contract}
        />
      )}

      <OptionButton
        Icon={<EditIcon />}
        onClick={() => setIsOpenEditModal(true)}
      >
        Update Account
      </OptionButton>
    </>

  );
}
